import Icon from "@builder/components/general/Icon"
import OliverText from "@builder/components/general/OliverText"
import "./style.scss"


export const IconTitle = ({ iconUrl, title, textColor = "base-blue", subtitle = "" }: { iconUrl?: string, title: string, textColor?: string, subtitle?: string }) => {
    return <div className="icon-title">
        <div className="icon-title-text">
            {iconUrl && <Icon src={iconUrl}/>}
            <OliverText text={title} size="s" color={textColor as any} />
        </div>
            {subtitle && <OliverText text={subtitle} size="xs" color="base-grey" />}
    </div>
}